

const COLOR_DEPTH = [
  "#929292","#869299","#7a91a0","#6f91a7","#6390ae","#5790b6",
  "#4b8fbd","#3f8fc4","#338ecb","#288ed2","#1c8dd9","#108de0",
  "#048ce7","#0c90de","#1f97cc","#329eb9","#45a5a7","#58ac94",
  "#6bb382","#7eba6f","#90c15d","#a3c84a","#b6cf38","#c9d625",
  "#dcdd13","#efe400","#eedb00","#eed200","#edc800","#edbf00",
  "#ecb600","#ebad00","#e69802","#de7b05","#d65e08","#ce410b",
  "#c6240e","#be0811","#c40b2d","#ce1a51","#d92876","#e3379a",
  "#ed46be","#f855e3","#f95af5","#e44be0","#cf3ccb","#ba2db5",
  "#a61ea0","#910f8a",
  //"#7c0075",
]

const COLOR_VIS = [
  "#bc0012","#d25009","#e9a101","#edc200","#efde00","#e1df0e",
  "#d0d91f","#bfd22f","#adcc40","#9cc551","#8bbf62","#79b973",
  "#68b284","#57ac95","#45a6a6","#349fb7","#2399c8","#1192d9",
  "#008cea","#0086e1","#0080d8","#007bd0","#0075c7","#006fbe",
  "#0069b5","#0063ac","#005da3","#00589b","#005292","#004c89",
]

const COLOR_TMP = [
  //"#004680", 
  "#004984", "#004b89", "#004e8d", "#005191", "#005496", 
  "#00579a", "#005a9e", "#005da2", "#005fa7", "#0062ab", "#0065af", 
  "#0068b4", "#006bb8", "#006ebc", "#0070c1", "#0073c5", "#0076c9", 
  "#0079ce", "#007cd2", "#007fd6", "#0081da", "#0084df", "#0087e3", 
  "#008ae7", "#028de8", "#0c91de", "#1594d5", "#1f98cc", "#289bc3", 
  "#329fb9", "#3ba2b0", "#45a6a7", "#4ea99d", "#58ac94", "#61b08b", 
  "#6bb382", "#74b778", "#7eba6f", "#87be66", "#91c15c", "#9ac553", 
  "#a4c84a", "#adcc41", "#b7cf37", "#c0d32e", "#c9d625", "#d3da1b", 
  "#dcdd12", "#e6e109", "#efe400", "#efe000", "#efdb00", "#eed700", 
  "#eed200", "#eecd00", "#eec900", "#edc400", "#edbf00", "#edbb00", 
  "#ecb600", "#ecb200", "#ecad00", "#eba600", "#e79801", "#e38903", 
  "#df7b04", "#db6c06", "#d65e08", "#d24f09", "#ce410b", "#ca320c", 
  "#c6240e", "#c2160f", "#be0711", "#bf031a", "#c40a2d", "#c9123f", 
  "#ce1951", "#d42163", "#d92876", "#de3088", "#e3379a", "#e93eac", 
  "#ee46bf", "#f34dd1", "#f855e3", "#fd5cf5", "#f95af6", "#ef53eb", 
  "#e44be0", "#da44d6", "#cf3ccb", "#c534c0", "#bb2db5", "#b025ab", 
  "#a61ea0", "#9b1695", "#910f8a", "#860780", "#7c0075", 
]


const COLORS_UNIFORMS = {
  RST: [0, 5],
  HYD: [0, 6],
  SDP: [0, 20],
  VIS: [0, 30],
  SKT: [-40, 60]
}

function getColorDef(values, minValue, maxValue, unit, labelIndex, toFixed) {

  let step = (maxValue - minValue) / values.length
  return values.map((v, index) => {

    const min = minValue + index * step;
    const max = min + step;

    const row = {
      "value": v,
      "min": min,
      "max": max,
      "unit": unit,
    }

    if (index == 0) {
      row["text_left"] = min.toFixed(toFixed)
    }

    if (labelIndex) {
      if (labelIndex.indexOf(index+1) > -1) {
        row["text_right"] = max.toFixed(toFixed)
      }
    } else {
      row["text_right"] = max.toFixed(toFixed)
    }

    return row
  })
}

export const COLORS_DEF = {
  ROADCOND: [
    { "value": "rgba(255, 255, 255, 1.0)", "text": "正常" },
    { "value": "rgba(255,   0,   0, 0.2)", "text": "警告" },
  ],
  
  RST: [
    { "value": "#929293", "text": "干燥" },
    { "value": "#FBE94B", "text": "湿滑" },
    { "value": "#FF9626", "text": "积水" },
    { "value": "#CB2E34", "text": "结冰" },
    { "value": "#B01BB6", "text": "积雪" }
  ],

  RADAR: [
    {"value": "rgb(  1, 160, 246)", "text":  "小"},
    {"value": "rgb(  0, 236, 236)", "text":  ""},
    {"value": "rgb(  0, 216,   0)", "text":  ""},
    {"value": "rgb(  0, 144,   0)", "text":  ""},
    {"value": "rgb(255, 255,   0)", "text":  ""},
    {"value": "rgb(231, 192,   0)", "text":  ""},
    {"value": "rgb(255, 144,   0)", "text":  "中"},
    {"value": "rgb(255,   0,   0)", "text":  ""},
    {"value": "rgb(214,   0,   0)", "text":  ""},
    {"value": "rgb(192,   0,   0)", "text":  ""},
    {"value": "rgb(255,   0, 240)", "text":  ""},
    {"value": "rgb(150,   0, 180)", "text":  ""},
    {"value": "rgb(173, 144, 240)", "text":  "大"}
  ],

  // HYD 0-6 mm (26 values)
  HYD: getColorDef(COLOR_DEPTH, 
    COLORS_UNIFORMS.HYD[0], COLORS_UNIFORMS.HYD[1], "mm", 
    [10, 20, 30, 40, 50], 1),
  // SDP 0-20cm
  SDP: getColorDef(COLOR_DEPTH, 
    COLORS_UNIFORMS.SDP[0], COLORS_UNIFORMS.SDP[1], "cm", 
    [10, 20, 30, 40, 50], 1),
  // VIS 0-30km
  VIS: getColorDef(COLOR_VIS, 
    COLORS_UNIFORMS.VIS[0], COLORS_UNIFORMS.VIS[1], "km", 
    [5, 10, 15, 20, 25, 30], 0),
  // SKT -40-60 C
  SKT: getColorDef(COLOR_TMP, 
    COLORS_UNIFORMS.SKT[0], COLORS_UNIFORMS.SKT[1], "℃", 
    [20, 40, 60, 80, 100], 0)
}

function getRGB(value) {
  const rgbs = []
  for(var i = 1; i < 7; i +=2) {
    rgbs.push(parseInt("0x" + value.slice(i, i+2)) / 255.00)
  }
  return rgbs
}

export function getColorUniforms(varType) {
  const settings = COLORS_UNIFORMS[varType]
  const colors = COLORS_DEF[varType]
  let step = (settings[1] - settings[0]) / colors.length;
  const values = []

  const maxRgbs = getRGB(colors[colors.length - 1].value)

  for(let i = 0; i < 100; i = i + 1) {
    values.push(maxRgbs[0])
    values.push(maxRgbs[1])
    values.push(maxRgbs[2])
  }

  colors.map((row, index) => {
    const rgbs = getRGB(row.value)
    values[index * 3] = rgbs[0];
    values[index * 3 + 1] = rgbs[1];
    values[index * 3 + 2] = rgbs[2];
  })

  return {
    uColorMin: settings[0] * 100.0,
    uColorStep: step * 100.0,
    uColorValues: values,
    uColorLength: colors.length
  }
}

export default {
  COLORS_DEF
}
